import { calendarFormat } from "services/utility/dates";

export function beforeSave(record) {
  const newRecord = { ...record };
  newRecord.closingDate = record.closingDate
    ? calendarFormat(record.closingDate)
    : null;
  return newRecord;
}
